<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <path d="M1 3C1 1.89543 1.89543 1 3 1H5.5C5.77614 1 6 0.776142 6 0.5C6 0.223858 5.77614 0 5.5 0H3C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H11C12.6569 14 14 12.6569 14 11V8.5C14 8.22386 13.7761 8 13.5 8C13.2239 8 13 8.22386 13 8.5V11C13 12.1046 12.1046 13 11 13H7V9C7 7.89543 6.10457 7 5 7H1V3ZM1 8H5C5.55228 8 6 8.44772 6 9V13H3C1.89543 13 1 12.1046 1 11V8ZM8 0.5C8 0.223858 8.22386 0 8.5 0H13.5C13.7761 0 14 0.223858 14 0.5V5.5C14 5.77614 13.7761 6 13.5 6C13.2239 6 13 5.77614 13 5.5V1.70711L8.85355 5.85355C8.65829 6.04882 8.34171 6.04882 8.14645 5.85355C7.95118 5.65829 7.95118 5.34171 8.14645 5.14645L12.2929 1H8.5C8.22386 1 8 0.776142 8 0.5Z" />
  </svg>
</template>
